import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';
import { Metric } from '@widgets/models/Metric';
import { DashboardService } from '@widgets/services/dashboard.service';
import { DASHBOARD_TIME_PERIOD_FILTERS, DASHBOARD_MONTH_FILTER_INDEX } from '@widgets/assets/constants';

@Component({
  selector: 'lms-metric',
  templateUrl: './metric.component.html',
  styleUrls: ['./metric.component.scss']
})
export class MetricComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public metric: Metric;
  public widgetId: string = 'METRICS';
  public filterList = DASHBOARD_TIME_PERIOD_FILTERS;
  public defaultFilter: any;
  public clientSubscriptionType: string;
  public clientId: string;

  constructor(public dashboardService: DashboardService) {}

  public ngOnInit(): void {
    this.setMetricData(this.data['metric']);
    const client = this.data.managedAccounts.length === 1 ? this.data.managedAccounts[0] : null;
    this.clientId = client ? client.id : null;

    // Remove subscription filter for credits clients
    this.clientSubscriptionType = client && client.subscriptions.credits ? 'credits' : 'users';
    this.filterList =
      this.clientSubscriptionType === 'credits' || this.data.managedAccounts.length > 1
        ? DASHBOARD_TIME_PERIOD_FILTERS.filter((option) => option.filter !== 'subscription')
        : DASHBOARD_TIME_PERIOD_FILTERS;

    this.defaultFilter = this.filterList[DASHBOARD_MONTH_FILTER_INDEX];
  }

  private setMetricData(metric: Metric) {
    this.metric = metric;
  }

  /**
   * Set and request the filter selected
   * @param selectedFilter
   */
  public setFilter(selectedFilter: any): void {
    if (selectedFilter.filter !== this.defaultFilter.filter) {
      this.defaultFilter = selectedFilter;
      this.dashboardService
        .getWidgetData(this.data['clientIds'], 'metrics', { timePeriod: selectedFilter['filter'] })
        .subscribe((metric: Metric) => {
          this.setMetricData(metric);
        });
    }
  }
}
